module.exports = "/resources/assets/prod/25aeeecd24dc8608dc8f6442cdfd42f2.jpg";